export enum PolicyType {
    PASSWORD = 'PASSWORD',
    MFA = 'MFA',
    EMAIL_DOMAIN = 'EMAIL_DOMAIN'
}
